import React from 'react'
import "./style.scss"
import Banner from "./banner"
import Products from "./products"

function index() {
    return (
        <div>
            <Banner />
            <Products />
        </div>
    )
}

export default index